import { render } from "./currencysettingsmodal.vue?vue&type=template&id=8f0b9748"
import script from "./currencysettingsmodal.vue?vue&type=script&lang=js"
export * from "./currencysettingsmodal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__